import { useTranslation } from 'react-i18next'
import type { TFunction } from 'i18next'
import type { AttendanceMark } from '../../types/entities'

const MARKS: Array<{ key: AttendanceMark; labelKey: string; color: string }> = [
  { key: 'present',   labelKey: 'present',   color: 'bg-green-100 text-green-700 border-green-300 hover:bg-green-200' },
  { key: 'late',      labelKey: 'lateShort', color: 'bg-yellow-100 text-yellow-700 border-yellow-300 hover:bg-yellow-200' },
  { key: 'absent',    labelKey: 'absentShort',  color: 'bg-red-100 text-red-700 border-red-300 hover:bg-red-200' },
  { key: 'sick',      labelKey: 'sickShort',  color: 'bg-blue-100 text-blue-700 border-blue-300 hover:bg-blue-200' },
  { key: 'excused',   labelKey: 'excusedShort', color: 'bg-violet-100 text-violet-700 border-violet-300 hover:bg-violet-200' },
  { key: 'unexcused', labelKey: 'unexcusedShort', color: 'bg-gray-100 text-gray-700 border-gray-300 hover:bg-gray-200' },
]

export function markTitle(key: AttendanceMark, t: TFunction): string {
  return t(`markPicker.title_${key}`)
}

/** Ряд кнопок-метров для одного ученика; клик → onChange. */
export function MarkPicker({
  selected,
  onChange,
}: {
  selected: AttendanceMark | undefined
  onChange: (m: AttendanceMark) => void
}) {
  const { t } = useTranslation()
  return (
    <div className="flex gap-1">
      {MARKS.map((m) => (
        <button
          key={m.key}
          onClick={() => onChange(m.key)}
          title={markTitle(m.key, t)}
          className={`w-9 h-9 rounded-md border text-xs font-semibold transition-all ${
            selected === m.key
              ? m.color + ' ring-2 ring-primary scale-105'
              : 'bg-white border-gray-200 text-gray-400 hover:border-gray-300'
          }`}
        >
          {m.key === 'present' ? '+' : t(`markPicker.${m.labelKey}`)}
        </button>
      ))}
    </div>
  )
}
